import React from 'react';
import * as S from './CellFormatter.styles';
import Brand from '../../Image/Brand/Brand';

export const BrandFormatter = ({ cell, formatExtraData }) =>
  cell ? (
    <S.Cell align={formatExtraData.align}>
      <Brand
        name={cell}
        alt={cell}
        width={48}
        height={32}
        cursor={formatExtraData.clickableRows ? 'pointer' : 'default'}
      />
    </S.Cell>
  ) : null;
